import { PanelOption, InverterOption, RoofType, MountingSystem, InstallationMethod } from './ConfiguratorProvider';

export const panelOptions: PanelOption[] = [
  {
    id: 'jinko-tiger-420',
    brand: 'Jinko Solar',
    model: 'Tiger Neo 420W',
    wattage: 420,
    efficiency: 21.1,
    price: 145
  },
  {
    id: 'jinko-tiger-450',
    brand: 'Jinko Solar', 
    model: 'Tiger Neo 450W',
    wattage: 450,
    efficiency: 22.3,
    price: 165
  },
  {
    id: 'tw-solar-400',
    brand: 'TW Solar',
    model: 'Mono PERC 400W',
    wattage: 400,
    efficiency: 20.6,
    price: 135
  },
  {
    id: 'tw-solar-435',
    brand: 'TW Solar',
    model: 'Mono PERC 435W',
    wattage: 435,
    efficiency: 21.8,
    price: 155
  },
  {
    id: 'aiko-stellar-440',
    brand: 'Aiko Solar',
    model: 'Stellar 440W',
    wattage: 440,
    efficiency: 22.1,
    price: 160
  },
  {
    id: 'trina-vertex-450',
    brand: 'Trina Solar',
    model: 'Vertex 450W',
    wattage: 450,
    efficiency: 21.9,
    price: 158
  }
];

export const inverterOptions: InverterOption[] = [
  {
    id: 'growatt-min-3000',
    brand: 'Growatt',
    model: 'MIN 3000TL-X',
    power: 3000,
    hybrid: false,
    price: 485
  },
  {
    id: 'growatt-min-4200',
    brand: 'Growatt',
    model: 'MIN 4200TL-X',
    power: 4200,
    hybrid: false,
    price: 525
  },
  {
    id: 'growatt-min-5000',
    brand: 'Growatt',
    model: 'MIN 5000TL-X',
    power: 5000,
    hybrid: false,
    price: 565
  },
  {
    id: 'growatt-mod-3000',
    brand: 'Growatt',
    model: 'MOD 3000TL3-X',
    power: 3000,
    hybrid: true,
    price: 725
  },
  {
    id: 'growatt-mod-5000',
    brand: 'Growatt',
    model: 'MOD 5000TL3-X',
    power: 5000,
    hybrid: true,
    price: 825
  },
  {
    id: 'growatt-mod-8000',
    brand: 'Growatt',
    model: 'MOD 8000TL3-X',
    power: 8000,
    hybrid: true,
    price: 945
  }
];

export const roofTypes: RoofType[] = [
  {
    id: 'tile-roof',
    name: 'Pannendak',
    description: 'Traditioneel pannendak (keramische of betonnen pannen)'
  },
  {
    id: 'flat-roof',
    name: 'Plat dak',
    description: 'Plat dak met EPDM, bitumen of andere dakbedekking'
  },
  {
    id: 'steel-deck',
    name: 'Stalen dak',
    description: 'Stalen dekplaten of sandwichpanelen'
  },
  {
    id: 'slate-roof',
    name: 'Leisteen dak',
    description: 'Leistenen dakbedekking'
  },
  {
    id: 'metal-roof',
    name: 'Metalen dak',
    description: 'Metalen dakplaten (zink, aluminium, etc.)'
  }
];

export const mountingSystems: MountingSystem[] = [
  {
    id: 'tile-hook-system',
    name: 'Panhaak systeem',
    roofTypes: ['tile-roof'],
    price: 45,
    description: 'Standaard haken voor pannendaken'
  },
  {
    id: 'flat-roof-ballast',
    name: 'Ballast systeem',
    roofTypes: ['flat-roof'],
    price: 65,
    description: 'Gewichtssysteem voor platte daken zonder dakdoorvoer'
  },
  {
    id: 'flat-roof-penetrating',
    name: 'Doorvoer systeem',
    roofTypes: ['flat-roof'],
    price: 55,
    description: 'Bevestiging met dakdoorvoeren'
  },
  {
    id: 'steel-clamp-system',
    name: 'Klem systeem',
    roofTypes: ['steel-deck', 'metal-roof'],
    price: 50,
    description: 'Klemmen voor stalen/metalen daken'
  },
  {
    id: 'slate-hook-system',
    name: 'Leisteen haken',
    roofTypes: ['slate-roof'],
    price: 75,
    description: 'Speciale haken voor leistenen daken'
  }
];

export const installationMethods: InstallationMethod[] = [
  {
    id: 'portrait-1-row',
    name: 'Portret - 1 rij',
    description: 'Panelen staand geplaatst in 1 rij',
    rows: 1,
    orientation: 'portrait'
  },
  {
    id: 'portrait-2-rows',
    name: 'Portret - 2 rijen',
    description: 'Panelen staand geplaatst in 2 rijen',
    rows: 2,
    orientation: 'portrait'
  },
  {
    id: 'portrait-3-rows',
    name: 'Portret - 3 rijen',
    description: 'Panelen staand geplaatst in 3 rijen',
    rows: 3,
    orientation: 'portrait'
  },
  {
    id: 'landscape-1-row',
    name: 'Liggend - 1 rij',
    description: 'Panelen liggend geplaatst in 1 rij',
    rows: 1,
    orientation: 'landscape'
  },
  {
    id: 'landscape-2-rows',
    name: 'Liggend - 2 rijen',
    description: 'Panelen liggend geplaatst in 2 rijen',
    rows: 2,
    orientation: 'landscape'
  },
  {
    id: 'landscape-3-rows',
    name: 'Liggend - 3 rijen',
    description: 'Panelen liggend geplaatst in 3 rijen',
    rows: 3,
    orientation: 'landscape'
  }
];